<template>
  <div>
    <v-row>
      <v-col>
        <div class="text-h4 font-weight-bold my-2 text-darkblue">Les finances sur la plateforme</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="pa-1 bordered rounded bg-grey_3">
          <FinancesOverview></FinancesOverview>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="text-h4 font-weight-bold my-2 text-darkblue">Les finances de l'organisateur</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div>
          <FinancesOrgaOverview></FinancesOrgaOverview>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FinancesOverview from "./FinancesOverview.vue";
import FinancesOrgaOverview from "./FinancesOrgaOverview.vue";

export default {
  components: { FinancesOverview, FinancesOrgaOverview },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>